import { useEffect } from "react";

type TWealthReaderWidget = {
  operationId: string;
};

const BASE_CLASS = "wealthReaderWidget";
const ScriptId = "wr-script";

export const WealthReaderWidget: React.FC<TWealthReaderWidget> = ({
  operationId,
}) => {
  useEffect(() => {
    // load.js lee la configuración global en el momento de ejecutarse,
    // por lo que debe establecerse antes de inyectar el script.
    (window as any).wr_conf = {
      operation_id: operationId,
      entities_to_display: [],
      wait_full_response: true,
      product_types: "accounts,portfolios",
    };

    // El script se reinyecta en cada montaje: al volver a la pantalla el
    // script antiguo ya se ejecutó y no volvería a inicializar el widget.
    const previousScript = document.getElementById(ScriptId);
    if (previousScript) {
      previousScript.remove();
    }

    const script = document.createElement("script");
    script.id = ScriptId;
    script.src = "https://widget.wealthreader.com/js/load.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
      delete (window as any).wr_conf;
    };
  }, [operationId]);

  return (
    <div className={BASE_CLASS}>
      <iframe
        id="wr-iframe"
        title="Wealth Reader widget"
        className={`${BASE_CLASS}__iframe`}
        referrerPolicy="origin"
      />
    </div>
  );
};
